import { render, staticRenderFns } from "./AddEditStudent.vue?vue&type=template&id=993b928e"
import script from "./AddEditStudent.vue?vue&type=script&lang=js"
export * from "./AddEditStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports